'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var tslib = require('tslib');
var styledComponents = require('./styled-components.js');

var StatCard = function (props) {
    var title = props.title, statistic = props.statistic, description = props.description, chart = props.chart, _a = props.className, className = _a === void 0 ? '' : _a, height = props.height, _b = props.statsStyle, statsStyle = _b === void 0 ? {} : _b, _c = props.descriptionStyle, descriptionStyle = _c === void 0 ? {} : _c, _d = props.statContainerStyle, statContainerStyle = _d === void 0 ? {} : _d, _e = props.chartContainerStyle, chartContainerStyle = _e === void 0 ? {} : _e;
    return (React__default.createElement(styledComponents.SizedCard, { className: className, height: height },
        React__default.createElement(styledComponents.StyledCardContent, null,
            React__default.createElement(styledComponents.Title, null, title),
            React__default.createElement(styledComponents.ContentContainer, { style: statsStyle },
                React__default.createElement("div", { style: tslib.__assign({ flex: 1.5 }, statContainerStyle) },
                    React__default.createElement(styledComponents.Statistic, { style: statsStyle }, statistic),
                    description && React__default.createElement(styledComponents.Description, { style: descriptionStyle }, description)),
                React__default.createElement(styledComponents.AlignedChart, { style: chartContainerStyle }, chart)))));
};

module.exports = StatCard;
